import { win } from '@rei/browser-shim';
import createApp from './main';
import { getClientPageData } from '../../utils/dom';

import '../../../style/global.scss';
import '../../../style/pages/session/entry.scss';

/**
 * Initialize the session page analytics
 */
const init = () => {
  /*
    Analytics are handled by window.metrics object, which is provided by Crampon 4
  */
  if (win.metrics && win.analyticsData) {
    const { courseTitle, siteId, sessionId, templateType } = win.analyticsData;
    /*
      formats the pageName properly.
      example: opo:session detail_Introduction to Road Cycling Class_212121
    */
    const pageName = `${siteId}:${templateType}_${courseTitle}_${sessionId}`;
    win.metrics.view({ pageName });
  }
};

const { pageData: props } = getClientPageData();

const { app } = createApp(props);
app.mount('#app');
init();
